import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbCardModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ZAuthService } from './../services';
import { SuppliersBarcodesRouting } from './supplier-barcodes.routing';
import { SuppliersBarcodesComponent } from './supplier-barcodes.component';
import { OrderDetailsListComponent } from './details-list/order-details-list.component';
import { OrderDetailsViewComponent } from './details-view/order-details-view.component';
import { SupplierOrderService } from './services/supplier-order.service';
import { PalletQtyRenderComponent } from './details-view/pallet-qty-render.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';


@NgModule({
  imports: [
    CommonModule,
    NbCardModule,
    Ng2SmartTableModule,
    SuppliersBarcodesRouting,
    NgSelectModule,
    FormsModule,
  ],
  providers: [ZAuthService, SupplierOrderService],
  declarations: [
    SuppliersBarcodesComponent,
    OrderDetailsViewComponent, PalletQtyRenderComponent,
    OrderDetailsListComponent,
  ],
  entryComponents: [OrderDetailsViewComponent, PalletQtyRenderComponent]
})
export class SuppliersBarcodesModule { }



// WEBPACK FOOTER //
// ./src/app/suppliers-barcodes/supplier-barcodes.module.ts